function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext } from 'react';
import { useStore as useStoreNative } from 'zustand';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { useBIRelationshipScope } from "../providers/BIRelationshipScopeProvider";
import { jsx as _jsx } from "react/jsx-runtime";
const StoreContext = /*#__PURE__*/createContext(undefined);
export function useStore(selector) {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return useStoreNative(store, selector);
}
export function useStoreStatic() {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useStoreStatic must be used within a StoreProvider');
  }
  return {
    getState: store.getState
  };
}

/**
 * Same as useStore but with built-in shallow object/array comparison. Use this hook
 * if you want to construct a single object/array with multiple state-picks inside,
 * similar to redux's mapStateToProps.
 * @see https://github.com/pmndrs/zustand#selecting-multiple-state-slices
 */
export function useShallowStore(selector) {
  const store = useContext(StoreContext);
  if (!store) throw new Error('useShallowStore must be used within a StoreProvider');
  return useStoreWithEqualityFn(store, selector, shallow);
}

/**
 * A convenience method that returns the actions from the store.
 * It's configured in eslint to be static, so the actions don't need
 * to be added to the dependency array in hooks that use them.
 */
export const useStoreActions = () => {
  const relationshipScope = useBIRelationshipScope();
  const actions = useStore(actionsSelector);
  const relationshipScopedLogBI = (id, data) => actions.logBI(id, _objectSpread(_objectSpread({}, data), {}, {
    relationshipId: relationshipScope && relationshipScope.id,
    isApprovedRelationship: relationshipScope && relationshipScope.isApproved
  }));
  return _objectSpread(_objectSpread({}, actions), {}, {
    logBI: relationshipScopedLogBI
  });
};
const actionsSelector = state => state.actions;
export function withStoreActions(Component) {
  const WithStoreActions = props => {
    const actions = useStoreActions();
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      actions: actions
    }));
  };
  return WithStoreActions;
}
export const Provider = StoreContext.Provider;
export function useAppConfig() {
  return useStore(appConfigSelector);
}
const appConfigSelector = state => state.appConfig;